import React, { PureComponent } from 'react'
import { Grid, Paper, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core'
import SpenceShopInfoItem from './SpenceShopInfoItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import { hasAccess } from '../../utils/api'

const SpenceShopInfoItemEditable = EditableHOCWrapper(SpenceShopInfoItem)

class SpenceShopInfo extends PureComponent {
  render() {
    const { shopsList = {}, spenceList = {}, onSave, lastModified, onDelete } = this.props
    const { values = [] } = shopsList

    return (
      <div>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper className="margin-top-small">
            <div className="table-scroll">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Shop Name</TableCell>
                    <TableCell>Spence Store Id</TableCell>
                    <TableCell>Environment</TableCell>
                    <TableCell>Status</TableCell>
                    {hasAccess() ? <TableCell></TableCell> : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(values &&
                    values.length &&
                    values.map((shop, index) => {
                      return (
                        <SpenceShopInfoItemEditable
                          key={index}
                          dataToEdit={spenceList[shop.id]}
                          isNotLinkedApiKey={
                            spenceList[shop.id] && spenceList[shop.id].apiKey ? false : true
                          }
                          onSave={onSave}
                          lastModified={lastModified}
                          shop={shop}
                          onDelete={onDelete}
                        />
                      )
                    })) ||
                    null}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Grid>
      </div>
    )
  }
}

export default SpenceShopInfo



// WEBPACK FOOTER //
// ./src/components/Spence/SpenceShopInfo.js